const promoClose = () => {
    const promoClose = document.querySelector('.promo--footer .promo-close');
    if (promoClose) {
        promoClose.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelector('.promo--footer').classList.add('invisible');

            // Save close
            let xhttp = new XMLHttpRequest();
            xhttp.open("POST", pokaa.ajaxurl, true);
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send("action=save_promo_close");

        });
    }

}

export default promoClose;